import { useEffect, useState } from 'react';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getCreativeTrendDetail } from '@opm/services';
import { useStableValue } from '@opm/utils/stableKey';
import { ITrendDetail } from '../types';

/**
 * 详情页 Common Details 数据 Hook
 * - 详情页通过 useFilterFromShortId 恢复 filter（含 game_id + topic）后调用
 * - 返回 ITrendDetail（KPI / AI Summary / 类目等）
 */
export function useCreativeTrendDetails({ filter }: { filter: any }) {
  const [data, setData] = useState<ITrendDetail | null>(null);
  const { wrapperCancelRequest, loading } = useCancelRequestHook({
    clear: () => setData(null),
  });

  const stableFilter = useStableValue(filter);

  useEffect(() => {
    if (!stableFilter?.game_id || !stableFilter?.topic) return;
    wrapperCancelRequest(getCreativeTrendDetail, stableFilter)
      .then((response: any) => {
        setData(response || null);
      })
      .catch(() => {});
  }, [stableFilter]);

  return { data, loading };
}
